import React, { useEffect, useState } from "react";
import { Typography, Box, Paper } from "@mui/material";

export default function Time() {
  const [time, setTime] = useState("");

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();

      const indiaTime = now.toLocaleTimeString("en-IN", {
        timeZone: "Asia/Kolkata",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });

      setTime(indiaTime);
    };

    updateTime();

    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box display="flex" justifyContent="center" mt={1} >
      <Paper sx={{ padding: 1, borderRadius: 3 } }> 
        <Typography variant="h4" fontWeight="bold">
          {time}
        </Typography>
      </Paper>
    </Box>
  );
}